module.exports = __webpack_public_path__ + "img/logo.6e1abb6d.png";